//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import toLogin from "./toLogin.vue";
import { getToken } from '@/libs/auth';
var ADMIN_ORIGIN = process.env.VUE_APP_ADMIN_ORIGIN || window.location.origin;
var STUDY_ORIGIN = process.env.VUE_APP_STUDY_ORIGIN || window.location.origin;
var TEACHER_ORIGIN = process.env.VUE_APP_TEACHER_ORIGIN || window.location.origin;
var BJCA_LOCAL_TEST_KEY = 'BJCA_LOCAL_TEST';
export default {
  name: "navHeader",
  props: {
    showBg: {
      type: Boolean,
      value: false
    }
    // showMenu: {
    //   type: Boolean,
    //   value: false
    // }
  },
  data: function data() {
    return {
      //  userInfo:{},
      navList: [],
      restaurants: [],
      searchType: "keyword",
      searchState: "",
      showHistory: false,
      searchHistoryList: ["语文", "牡丹", "计算机", "测试"],
      timer: null,
      showMenu: false,
      userLogin: {
        userHd: require("@/assets/img/user.png")
      },
      loginLogo: "",
      hdColor: 0,
      icveLoginName: ""
    };
  },
  components: {
    toLogin: toLogin
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.getters.userInfo || {};
    },
    showHeaderSearch: function showHeaderSearch() {
      return this.$route.path !== "/courseSearch" && this.$route.path !== "/semanticSearch";
    },
    searchPlaceholder: function searchPlaceholder() {
      return this.searchType === "semantic" ? "请输入想要学习的内容" : "请输入课程名称";
    }
  },
  watch: {
    "$route.path": function $routePath(value) {
      if (value === "/courseSearch" || value === "/semanticSearch") {
        this.searchState = "";
        this.showHistory = false;
      }
    }
  },
  created: function created() {
    this.$root.$on('open-portal-login', this.toLogin);
  },
  mounted: function mounted() {
    // 页面加载时，如果有token但没有用户信息，重新获取用户信息
    if (this.$store.getters.token && !this.userInfo.userName) {
      this.$store.dispatch('user/getInfo');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('open-portal-login', this.toLogin);
  },
  methods: {
    logoutToPortal: function logoutToPortal() {
      this.$store.dispatch("user/logout");
    },
    goHome: function goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    },
    handleSearch: function handleSearch() {
      var searchValue = (this.searchState || "").trim();
      this.showHistory = false;
      if (this.searchType === "semantic") {
        this.handleSemanticSearch(searchValue);
        return;
      }
      this.$router.push({
        path: "/courseSearch",
        query: searchValue ? {
          courseName: searchValue
        } : {}
      });
      this.searchState = "";
    },
    handleSearchTypeChange: function handleSearchTypeChange() {
      this.showHistory = false;
    },
    showHistoryPanel: function showHistoryPanel() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.showHistory = true;
    },
    hideHistoryPanel: function hideHistoryPanel() {
      var _this = this;
      this.timer = setTimeout(function () {
        _this.showHistory = false;
      }, 200);
    },
    handleHistorySearch: function handleHistorySearch(keyword) {
      this.searchState = keyword;
      this.handleSearch();
    },
    handleSemanticSearch: function handleSemanticSearch(value) {
      var query = (value || this.searchState || "").trim();
      if (!query) {
        return;
      }
      this.$router.push({
        path: "/semanticSearch",
        query: {
          query: query
        }
      });
      this.searchState = "";
    },
    //退出登录并清除cookie
    quitIcveLogin: function quitIcveLogin() {
      var _this2 = this;
      // sessionStorage.removeItem( "curNav" );
      // sessionStorage.removeItem( "$index" );
      // sessionStorage.removeItem( "sidebar" );
      // sessionStorage.removeItem( "zyList" );
      // sessionStorage.removeItem( "classList" );
      // sessionStorage.removeItem( "yxList" );
      // sessionStorage.removeItem( "ROLE" );
      // sessionStorage.removeItem( "USERTYPE" );
      // sessionStorage.removeItem( "ISSHOW" );
      // sessionStorage.removeItem( "displayName" );

      var loading = this.$loading({
        lock: true,
        text: '加载中。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      this.$store.dispatch("user/logout").then(function (res) {
        setTimeout(function () {
          loading.close();
          _this2.$message.success("退出成功！");
          //延迟跳转统一认证登出，让用户看到提示；注销CA会话，否则下次CA登录会免登录进原账号
        }, 2000);
      });
    },
    //注销北京统一认证会话
    toAdmin: function toAdmin() {
      var roles = this.$store.getters.roles || [];
      var userInfo = this.$store.getters.userInfo || {};
      var isLocalTestLogin = sessionStorage.getItem(BJCA_LOCAL_TEST_KEY) === 'true';
      var localTestToken = isLocalTestLogin ? getToken() : '';
      var links = '/icve-study/';
      var origin = STUDY_ORIGIN;

      // 教师用户可能同时拥有多个角色，不能先用角色数量判断管理端。
      if (String(userInfo.userType) === '2') {
        links = '/icve-teacher/';
        origin = TEACHER_ORIGIN;
      } else if (String(userInfo.userType) === '1') {
        links = '/icve-study/';
        origin = STUDY_ORIGIN;
      } else if (roles.length > 0) {
        links = '/icve-admin/login-icve';
        origin = ADMIN_ORIGIN;
      }
      var targetOrigin = new URL(origin, window.location.origin).origin;
      var handoffToken = localTestToken || (targetOrigin !== window.location.origin ? getToken() : '');
      var tokenParam = localTestToken ? 'localTestToken' : 'access_token';
      var query = handoffToken ? "?".concat(tokenParam, "=").concat(encodeURIComponent(handoffToken)) : '';
      sessionStorage.removeItem(BJCA_LOCAL_TEST_KEY);
      location.href = "".concat(origin).concat(links).concat(query);
    },
    toLogin: function toLogin() {
      this.$refs.toLogin.adminDia = true;
    }
  }
};